import {
  Typography
} from '@mui/material';
import { format, parseISO } from 'date-fns';

const ScheduleDetails = ({ config }) => {
  if (config.mode === 'ON_DEMAND') {
    return <Typography variant="body2">Manual trigger only</Typography>;
  }
  
  if (config.mode === 'ONE_TIME') {
    const scheduledTime = parseISO(config.scheduledTime);
    
    return (
      <>
        <Typography variant="body2">
          Scheduled at: {format(scheduledTime, 'PPpp')}
        </Typography>
        <Typography variant="body2">
          Time zone: {config.timeZoneStrategy === 'SPECIFIC' 
            ? config.specificTimeZone 
            : config.timeZoneStrategy}
        </Typography>
      </>
    );
  }
  
  // RECURRING mode
  return (
    <>
      <Typography variant="body2">
        Cron expression: <code>{config.cronExpression}</code>
      </Typography>
      <Typography variant="body2">
        Time zone strategy: {config.timeZoneStrategy}
        {config.timeZoneStrategy === 'SPECIFIC' && ` (${config.specificTimeZone})`}
      </Typography>
      {config.scheduleStartDate && (
        <Typography variant="body2">
          Active from: {format(parseISO(config.scheduleStartDate), 'PPP')}
        </Typography>
      )}
      {config.scheduleEndDate && (
        <Typography variant="body2">
          Active until: {format(parseISO(config.scheduleEndDate), 'PPP')}
        </Typography>
      )}
    </>
  );
};

export default ScheduleDetails;